import { useState } from "react";

import {
  createTemporaryLink,
  getDownloadDocumentPatient,
} from "../api/user-program";
import { IFileData } from "../interface/IFileData";
import { DocumentSection } from "../interface/ISections";

function useFileDownloader() {
  const [isFileDetailSelected, setIsFileDetailSelected] = useState(false);
  const [isFileDetailSelectedClinic, setIsFileDetailSelectedClinic] =
    useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
  const [temporaryUrl, setTemporaryUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [isAPdfFile, setIsPdfFile] = useState(false);
  const [isDocxFile, setIsDocxFile] = useState(false);

  const handleDownloadClicked = async (file: IFileData | DocumentSection) => {
    let url: string | undefined;
    let customFileName: string | undefined;

    if ("file" in file) {
      url = file.file;
    } else {
      url = file.url;
    }

    if ("name" in file) {
      customFileName = file.name;
    } else {
      customFileName = file.title;
    }

    const parts = url.split("/");
    const folderName = parts[parts.length - 2];
    const fileName = parts[parts.length - 1];

    setIsPdfFile(fileName.includes(".pdf"));
    setIsDocxFile(fileName.includes(".docx"));
    setFileName(customFileName);

    try {
      const temporaryUrl = await createTemporaryLink(folderName, fileName);

      setTemporaryUrl(temporaryUrl);
      setIsFileDetailSelected(true);
    } catch (error) {
      setIsFileDetailSelected(false);

      console.error("Error downloading document:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleDownloadClickedMmkBefund = async (
    file: IFileData | DocumentSection
  ) => {
    let url: string | undefined;
    let customFileName: string | undefined;

    if ("file" in file) {
      url = file.file;
    } else {
      url = file.url;
    }

    if ("name" in file) {
      customFileName = file.name;
    } else {
      customFileName = file.title;
    }

    const parts = url.split("/");
    const folderName = parts[parts.length - 2];
    const fileName = parts[parts.length - 1];

    setIsPdfFile(fileName.includes(".pdf"));
    setIsDocxFile(fileName.includes(".docx"));
    setFileName(customFileName);

    try {
      const temporaryUrl = await createTemporaryLink(folderName, fileName);

      setTemporaryUrl(temporaryUrl);

      setIsFileDetailSelectedClinic(true);
    } catch (error) {
      setIsFileDetailSelectedClinic(false);
      console.error("Error downloading document:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleDownloadTemporaryLink = async (path: string) => {
    const element = document.createElement("a");
    element.href = path;
    element.download = fileName;
    document.body.appendChild(element);
    (element as HTMLAnchorElement).click();
    document.body.removeChild(element);
  };

  return {
    handleDownloadClicked,
    handleDownloadClickedMmkBefund,
    handleDownloadTemporaryLink,
    isAPdfFile,
    getDownloadDocumentPatient,
    setIsDownloading,
    setIsFileDetailSelected,
    setIsFileDetailSelectedClinic,
    isDownloading,
    isFileDetailSelected,
    isFileDetailSelectedClinic,
    temporaryUrl,
    isDocxFile,
  };
}

export default useFileDownloader;
